import { DateManager } from '@payments-checkout/shared/helpers/index';
import { isLanguagePortuguese } from '@payments-checkout/shared/helpers/translations/internacional-address.helpers';
import { PlanInterval, Recurrences } from '../../types/paymentLink.types';

const formatRecurrenceValues = ({
  recurrence,
  locale,
}: {
  recurrence?: Recurrences;
  locale?: string;
}) => {
  if (!recurrence)
    return {
      membershipTax: 0,
      firstBillingDay: 0,
      formattedDateText: '',
      price: 0,
      interval: 'month' as PlanInterval,
      intervalCount: 1,
    };
  const localeParam = isLanguagePortuguese(locale) ? 'pt-BR' : 'en-US';
  const membershipTax = recurrence[0].setup?.amount;
  const firstBillingDay = recurrence[0]?.start_at;
  const billingType = recurrence[0]?.plan?.billing_type;

  const formattedDateText = firstBillingDay && DateManager.showOnlyDate(
    firstBillingDay,
    localeParam
  );

  const price = recurrence[0].plan.total_cost;
  const interval = recurrence[0].plan.interval;
  const intervalCount = recurrence[0].plan.interval_count;

  return {
    membershipTax,
    firstBillingDay,
    formattedDateText,
    price,
    interval,
    intervalCount,
    billingType
  };
};

export { formatRecurrenceValues };
